import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  token_container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: 14,
    paddingLeft: 50,
    paddingRight: 50,
    marginHorizontal: 20,
    marginTop: 12,
  },

  containerCard: {
    backgroundColor: "#FFF",
    width: 250,
    /* padding: 12, */
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
    alignItems: "center",
    marginBottom: 20,
  },

  header_image: {
    width: "100%",
    height: 150,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    marginBottom: 10,
  },

  asset_icon: {
    width: 24,
    height: 24,
    borderRadius: 25,
    marginBottom: 10,
  },

  asset_name: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#000",
    marginBottom: 10,
    textAlign: "center",
  },

  token_price: {
    color: "#000",
    fontWeight: "500",
    fontSize: 16,
    marginBottom: 20,
  },

  tokenBtnComprar: {
    width: "90%",
    paddingVertical: 10,
    backgroundColor: "#077A97",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    alignItems: "center",
    marginBottom: 10,
  },

  tokenTextComprar: {
    color: "#fff",
    fontWeight: "500",
    fontSize: 14,
  },

  tokenBtnDetalhes: {
    width: "90%",
    paddingVertical: 10,
    backgroundColor: "#fff",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    alignItems: "center",
    marginBottom: 12,
  },

  tokenTextDetalhes: {
    color: "#077A97",
    fontWeight: "500",
    fontSize: 14,
  },

  containerCardsPacotes: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignSelf: "center",
    alignItems: "center",
    maxWidth: "60%",
  },

  textBtnMapa: {
    textTransform: "uppercase",
    color: "#ffffff",
  },

  btncomprarMapa: {
    backgroundColor: "#0A9396",
  },
});

export default styles;
